import React, { FC, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { MDBBtn, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { BounceLoader } from "react-spinners";
import { slugify } from "@/utils/searchUtils";
import TagManager from "react-gtm-module";
import {
    createGA4ItemFromBlog,
    viewItemList,
} from "@/utils/analytics/tagmanager";
import CardStories from "../home/cards/CardStories";
import styles from "../../styles/italian-stories/ItalianStories.module.scss";
import useItalianStoriesData from "../../utils/queries/hooks/useItalianStoriesData";

const ItalianStoriesInfo: FC = () => {
    const [page, setPage] = useState(1);
    const router = useRouter();

    const { storiesData, isFetching, hasMoreItem } =
        useItalianStoriesData(page);

    useEffect(() => {
        if (storiesData?.length > 0) {
            TagManager.dataLayer(
                viewItemList(
                    "italian-stories",
                    "Pagina Italian Stories",
                    storiesData?.map((blog, index) =>
                        createGA4ItemFromBlog(
                            "italian-stories",
                            "Pagina Italian Stories",
                            blog,
                            index
                        )
                    )
                )
            );
        }
    }, [storiesData]);

    return (
        <MDBContainer fluid className={styles.containerInfo}>
            <MDBRow>
                {storiesData?.map(el => (
                    // eslint-disable-next-line no-underscore-dangle
                    <MDBCol key={el._id} size={12} md={6} lg={4}>
                        <CardStories
                            content={el}
                            onClick={() => {
                                router.push({
                                    pathname: "/italian-stories/[slug]",
                                    query: {
                                        // eslint-disable-next-line no-underscore-dangle
                                        slug: slugify(el.title),
                                    },
                                });
                            }}
                        />
                    </MDBCol>
                ))}
            </MDBRow>
            {isFetching && (
                <MDBRow className="w-100 justify-content-center my-5">
                    <BounceLoader color="#ed6f6f" size={150} />
                </MDBRow>
            )}
            {hasMoreItem && (
                <MDBRow className="d-flex justify-content-start">
                    <MDBCol size={10}>
                        <MDBBtn
                            className={`${styles.buttonLoad} shadow-0`}
                            onClick={() => setPage(page + 1)}
                        >
                            Load More
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            )}
        </MDBContainer>
    );
};

export default ItalianStoriesInfo;
